"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionColStyled = exports.LinksListItemStyled = exports.LinksListStyled = exports.SectionBodyStyled = exports.SectionHeadStyled = exports.SectionIconStyled = exports.SectionStyled = exports.SectionsStyled = exports.ContainerStyled = void 0;

var _container = require("@dbi-tools/ui-kit/lib/components/container");

var _list = require("@dbi-tools/ui-kit/lib/components/list");

var _uiKit = require("@dbi-tools/ui-kit");

var _headerTitles = require("../header-titles/header-titles.styled");

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    ", " {\n      border-top: 1px solid ", ";\n    }\n\n    &:nth-child(1),\n    &:nth-child(2) {\n      ", " {\n        border-top: none;\n      }\n    }\n  }\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  padding: 15px 0 !important;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  padding: 15px 0 0;\n  margin: 0;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  ", " {\n    font-size: 14px;\n    line-height: 21px;\n    font-weight: 300;\n    text-transform: none;\n    letter-spacing: normal;\n  }\n  a:hover {\n    text-decoration: underline;\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 50px;\n  min-width: 50px;\n  margin-right: 30px;\n\n  ", " {\n    width: 40px;\n    min-width: 40px;\n    margin-right: 20px;\n  }\n\n  img {\n    height: auto;\n    width: 100%;\n  }\n  ", " {\n    min-height: 50px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  height: 100%;\n  padding: 25px 0;\n\n  ", " {\n    border-bottom: 1px solid ", ";\n  }\n\n  .ReactCollapse--collapse {\n    transition: height 500ms;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 25px;\n\n  ", " {\n    margin-top: 15px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    padding: 60px 27px;\n    padding-bottom: ", ";\n    padding-top: ", ";\n\n    ", " {\n      padding: 30px 24px;\n      padding-bottom: ", ";\n      padding-top: ", ";\n    }\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", "\n\n  ", " {\n    ", " * {\n      font-size: 18px;\n      line-height: 27px;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ContainerStyled = (0, _uiKit.styled)(_container.Container)(_templateObject(), function (_ref) {
  var removeTopPadding = _ref.removeTopPadding,
      removeBottomPadding = _ref.removeBottomPadding;
  return (0, _uiKit.css)(_templateObject2(), removeBottomPadding ? 0 : '60px', removeTopPadding ? 0 : '60px', _uiKit.GridBreakpointsMediaDown.sm, removeBottomPadding ? 0 : '30px', removeTopPadding ? 0 : '30px');
}, _uiKit.GridBreakpointsMediaUp.md, _headerTitles.DescriptionStyled);
exports.ContainerStyled = ContainerStyled;
var SectionsStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject3(), _uiKit.GridBreakpointsMediaDown.md);
exports.SectionsStyled = SectionsStyled;
var SectionStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject4(), _uiKit.GridBreakpointsMediaDown.md, _uiKit.Colors.gray300);
exports.SectionStyled = SectionStyled;
var SectionIconStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject5(), _uiKit.GridBreakpointsMediaDown.lg, _uiKit.LoadingBlockStyled);
exports.SectionIconStyled = SectionIconStyled;
var SectionHeadStyled = (0, _uiKit.styled)('header')(_templateObject6());
exports.SectionHeadStyled = SectionHeadStyled;
var SectionBodyStyled = (0, _uiKit.styled)(_uiKit.Box)(_templateObject7(), _uiKit.ButtonStyled);
exports.SectionBodyStyled = SectionBodyStyled;
var LinksListStyled = (0, _uiKit.styled)(_list.ListStyled)(_templateObject8());
exports.LinksListStyled = LinksListStyled;
var LinksListItemStyled = (0, _uiKit.styled)(_list.ListItemStyled)(_templateObject9());
exports.LinksListItemStyled = LinksListItemStyled;
var SectionColStyled = (0, _uiKit.styled)(_uiKit.Col)(_templateObject10(), _uiKit.GridBreakpointsMediaUp.lg, SectionStyled, _uiKit.Colors.gray300, SectionStyled);
exports.SectionColStyled = SectionColStyled;